import React, { Component } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'

class Header_Nav extends Component {
    constructor(props) {
        super(props)
        this.state= {}
    }

    render(props) {
        return (
            <Navbar collapseOnSelect expand="lg" className='navbar-dark'>
                <Navbar.Toggle controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Link
                            href="#home"
                            className='navbar-link-text'
                            onClick={() => this.props.pageSelector('home')}>
                            HOME
                        </Nav.Link>
                        <Nav.Link
                            href="#services"
                            className='navbar-link-text'
                            onClick={() => this.props.pageSelector('services')}>
                            SERVICES
                        </Nav.Link>
                        <Nav.Link
                            href="#appointment"
                            className='navbar-link-text'
                            onClick={() => this.props.pageSelector('appointment')}>
                            MAKE AN APPOINTMENT
                        </Nav.Link>
                        <Nav.Link
                            href="#gallery"
                            className='navbar-link-text'
                            onClick={() => this.props.pageSelector('gallery')}>
                            GALLERY
                        </Nav.Link>
                        <Nav.Link
                            href="#contact"
                            className='navbar-link-text'
                            onClick={() => this.props.pageSelector('contact')}>
                            CONTACT US
                        </Nav.Link>
                        <Nav.Link
                            href="#login"
                            className='navbar-link-text'
                            >
                            LOGIN
                        </Nav.Link>
                        {/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                        </NavDropdown> */}
                    </Nav>
                </Navbar.Collapse>
                <div className='social-icons'>
                    <Nav.Link href="#deets"><i className='far fa-envelope' /></Nav.Link>
                    <Nav.Link href="https://www.instagram.com/dapper_doggy_day_spaw/" target='_blank'><i className='fab fa-instagram' /></Nav.Link>
                    <Nav.Link href="#deets"><i className='fab fa-yelp' /></Nav.Link>
                    <Nav.Link href="https://www.facebook.com/DapperDoggiesbyStephanie/" target='_blank'><i className='fab fa-facebook' /></Nav.Link>
                </div>
            </Navbar>
        )
    }
}

export default Header_Nav